<template>
  <div class="lang-select">
    <!-- <span :class="{ active: language === 'zh' }" @click="handleSetLanguage('zh')">中文</span> -->
    <span v-show="language !== 'en'" :class="{ active: language === 'en' }" @click="handleSetLanguage('en')">English</span>
    <span v-show="language !== 'spanish'" :class="{ active: language === 'spanish' }" @click="handleSetLanguage('spanish')">Español</span>
  </div>
</template>

<script>
export default {
  computed: {
    language() {
      return this.$store.getters.language
    }
  },
  watch: {
    language: {
      handler: function(newValue, oldValue) {
        if (newValue === 'zh') this.handleSetLanguage('spanish')
      },
      immediate: true
    }
  },
  methods: {
    handleSetLanguage(lang) {
      this.$i18n.locale = lang
      this.$store.dispatch('app/setLanguage', lang)
      this.$router.go(0)
      this.$emit('change', lang)
    }
  }
}
</script>
<style lang="scss" scoped>
.lang-select {
  font-size: 16px !important;
  display: inline-block;

  span {
    cursor: pointer;
    // color: rgba(255, 255, 255, .7);
    &.active {
      // color: #fff;
    }
    &:hover {
      color: #85BAE5;
    }
  }
}
</style>
